import { render, staticRenderFns } from "./Accessibility.vue?vue&type=template&id=0c3f5bdc&scoped=true&"
import script from "./Accessibility.vue?vue&type=script&lang=ts&"
export * from "./Accessibility.vue?vue&type=script&lang=ts&"
import style0 from "./Accessibility.vue?vue&type=style&index=0&id=0c3f5bdc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3f5bdc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VBtn,VContainer,VRadio,VRadioGroup})
